import Vue from 'vue'
import VueRouter from 'vue-router'
import Presale from '@/views/modules/presale/presale'
import GlobalArtView from '@/views/modules/globalArt/globalArtView'
import NexoCityView from '@/views/modules/nexoCity/nexoCityView'
import SmartBotView from '@/views/modules/smartBot/smartBotView'
import SmartWalletView from '@/views/modules/smartWallet/smartWalletView'
import SwapView from '@/views/modules/trade/swapView'
// import LiquidityView from '@/views/modules/trade/liquidityView'
import LiquidityPoolsView from '@/views/modules/earn/liquidityPoolsView'
import StakeUsersHomeView from '@/views/modules/earn/stake/stakeUsersHomeView'
import StakeUsersProfileView from '@/views/modules/earn/stake/stakeUsersProfileView'
import StakeView from '@/views/modules/earn/stakeView'
import StakeTeamView from '@/views/modules/stakeTeam/stakeTeamView'
import FarmingView from '@/views/modules/earn/farmingView'
import GameView from '@/views/modules/play/gameView'
import GamblingView from '@/views/modules/play/gamblingView'
import NotFoundView from '@/views/NotFoundView'
// import HomeView from '@/views/HomeView'
import Template from '@/components/Template'
Vue.use(VueRouter)

const routes = [
  {
    path: '/',
    redirect: '/presale'
  },
  {
    path: '/presale',
    component: Template,
    children: [
      {
        path: '',
        name: 'presale',
        component: Presale,
        meta: {
        }
      },
      {
        path: 'ref/:id',
        name: 'presale-ref',
        component: Presale,
        meta: {
        }
      },
      {
        path: 'ref/si/:id',
        name: 'presale-ref-si',
        component: Presale,
        meta: {
        }
      }
    ]
  },
  {
    path: '/trade',
    component: Template,
    children: [
      {
        path: 'swap',
        name: 'swap',
        component: SwapView,
        meta: { }
      },
      {
        path: 'liquidity',
        name: 'liquidity',
        redirect: '/earn/liquidity-pools'
      }
    ]
  },
  {
    path: '/earn',
    component: Template,
    children: [
      {
        path: 'liquidity-pools',
        name: 'liquidityPools',
        component: LiquidityPoolsView,
        meta: { }
      },
      {
        path: 'stake',
        component: Template,
        children: [
          {
            path: 'document',
            name: 'stake_document',
            component: StakeView,
            meta: { }
          },
          {
            path: 'profile',
            name: 'stake_user_profile',
            component: StakeUsersProfileView,
            meta: { }
          },
          {
            path: 'home',
            component: Template,
            children: [
              {
                path: '',
                name: 'stake_home',
                component: StakeUsersHomeView,
                meta: { }
              },
              {
                path: 'ref/:id',
                name: 'stake-home-ref',
                component: StakeUsersHomeView,
                meta: { }
              }
            ]
          }
        ]
      },
      {
        path: 'stake-team',
        name: 'stake-team',
        component: StakeTeamView,
        meta: { }
      },
      {
        path: 'farming',
        name: 'farming',
        component: FarmingView,
        meta: { }
      }
    ]
  },
  {
    path: '/global-art',
    name: 'global-art',
    component: GlobalArtView,
    meta: { }
  },
  {
    path: '/nexo-city',
    name: 'nexo-city',
    component: NexoCityView,
    meta: { }
  },
  {
    path: '/smart-bot',
    name: 'smart-bot',
    component: SmartBotView,
    meta: { }
  },
  {
    path: '/smart-wallet',
    name: 'smart-wallet',
    component: SmartWalletView,
    meta: { }
  },
  {
    path: '/play',
    component: Template,
    children: [
      {
        path: 'game',
        name: 'game',
        component: GameView,
        meta: { }
      },
      {
        path: 'gambling',
        name: 'gambling',
        component: GamblingView,
        meta: { }
      }
    ]
  },
  {
    path: '*',
    component: NotFoundView,
    meta: { }
  }
]

const router = new VueRouter({
  // mode: 'history',
  base: process.env.BASE_URL,
  routes
})

export default router
